import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,_vm._g(_vm._b({staticClass:"colored-svg-img"},'v-img',_vm.$attrs,false),_vm.$listeners),[(_vm.svgContent)?_c('div',{staticClass:"svg-wrapper",style:(_vm.cssVars),domProps:{"innerHTML":_vm._s(_vm.svgContent)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }